export const addFileToCategory = (payload?: any) => ({
    type: "@saga/ADD_FILE_TO_CATEGORY",
    payload
});

